export default __webpack_public_path__ + "static/media/dead_ley_line_leaves.47feb2d1.png";